/* ---------------------------------------------------------------
   A gaveta do carrinho — Moopey, 23/08/2026

   O tema (Symmetry) já faz a parte difícil: intercepta o formulário, envia por
   AJAX e chama `theme.addedToCartHandler`. **Não se lhe mexe nisso** — troca-se
   só o que ele faz no fim, que era mostrar uma barra ao cimo do ecrã com uma
   linha só. Reescrever a submissão do formulário numa loja que está a vender
   seria arriscar o que já funciona.

   **Quem desenha é o Liquid.** A gaveta inteira vem do `?sections=mvn-gaveta`,
   sugestões incluídas. Este ficheiro só abre, fecha e volta a pedir.

   Duas versões ficaram pelo caminho e vale a pena saber porquê: a primeira
   trazia as sugestões em JSON e formatava os preços com o `formatMoney` do
   tema — que rebenta se lhe chamarem sem o formato da moeda, e a caixa ficava
   vazia sem dizer nada. A segunda pedia-as a uma secção à parte pelo
   `/recommendations`, mas essa não sabe o que está no cesto e sugeria o que
   ele acabara de levar. Dinheiro, línguas e o que está no carrinho são com o
   Liquid.

   **Há duas jQuery na página** — a do tema e a de uma app. Por isso aqui não
   se usa jQuery nenhuma: só DOM, que não engana.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var SECCAO = 'mvn-gaveta';
  var gaveta, veu;

  function montar() {
    veu = document.querySelector('.mvn-veu');
    gaveta = document.querySelector('.mvn-gaveta');
    return !!(gaveta && veu);
  }

  function pedir(url) {
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; });
  }

  /* a Shopify embrulha a seccao num <div id="shopify-section-..."> */
  function desembrulhar(html) {
    var caixa = document.createElement('div');
    caixa.innerHTML = html;
    var dentro = caixa.querySelector('[id^="shopify-section-"]');
    return dentro ? dentro.innerHTML : caixa.innerHTML;
  }

  /* ---------- abrir e fechar ---------- */
  function abrir() {
    if (!gaveta && !montar()) return;
    // o tema tem o seu proprio aviso ao cimo do ecra; se estiver la, tira-se
    if (window.theme && typeof theme.removeAddedCartDrawer === 'function') {
      try { theme.removeAddedCartDrawer(); } catch (e) {}
    }
    veu.classList.add('aberta');
    gaveta.classList.add('aberta');
    document.documentElement.style.overflow = 'hidden';
    var f = gaveta.querySelector('.mvn-gaveta__fechar');
    if (f) f.focus({ preventScroll: true });
  }

  function fechar() {
    if (!gaveta) return;
    veu.classList.remove('aberta');
    gaveta.classList.remove('aberta');
    document.documentElement.style.overflow = '';
  }

  /* aplica as secções que vêm na própria resposta do /cart/add|change (um pedido só) */
  function aplicar(j) {
    if (!j || !j.sections || !j.sections[SECCAO]) return redesenhar();
    gaveta.innerHTML = desembrulhar(j.sections[SECCAO]);
    var saco = document.getElementById('cart-icon-bubble');
    if (saco && j.sections['cart-icon-bubble']) saco.innerHTML = desembrulhar(j.sections['cart-icon-bubble']);
    contaNoCabecalho();
    cronometro();
  }
  function enviar(url, corpo) {
    corpo.sections = SECCAO + ',cart-icon-bubble';
    corpo.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(corpo) })
      .then(function (r) { return r.json(); }).then(aplicar);
  }

  /* ---------- voltar a desenhar ---------- */
  function redesenhar() {
    return pedir('?sections=' + SECCAO + ',cart-icon-bubble')
      .then(function (txt) {
        if (!txt) return;
        var j;
        try { j = JSON.parse(txt); } catch (e) { return; }
        if (!j[SECCAO]) return;
        gaveta.innerHTML = desembrulhar(j[SECCAO]);
        /* Dawn: o saco do cabeçalho (com o número) vem na mesma resposta */
        var saco = document.getElementById('cart-icon-bubble');
        if (saco && j['cart-icon-bubble']) saco.innerHTML = desembrulhar(j['cart-icon-bubble']);
        contaNoCabecalho();
        cronometro();
      });
  }

  /* o numero do saco no cabecalho do tema, para nao ficar a mentir */
  function contaNoCabecalho() {
    var n = gaveta.querySelector('.mvn-gaveta__conta');
    if (!n) return;
    var quantos = n.textContent.trim();
    document.querySelectorAll('.cart-link__bubble-num, .cart-count, [data-cart-count]')
      .forEach(function (e) { e.textContent = quantos; });
  }

  /* ---------- sugestoes ----------
     Ja nao ha nada a fazer aqui: os mais vendidos sao desenhados dentro da
     propria seccao, em Liquid, porque so ai se sabe o que esta no cesto para
     nao o sugerir outra vez. A versao anterior pedia-os ao
     `/recommendations` e nao conseguia excluir o que ele acabara de levar. */

  /* ---------- o cronometro da urgencia ----------
     Dez minutos. **A hora de arranque vive no `sessionStorage`**, nao numa
     variavel: a gaveta e redesenhada de cada vez que o carrinho muda, e sem
     isto o relogio voltava aos 10:00 a cada clique — que se ve logo que e
     falso. Assim conta do primeiro momento em que ele poe alguma coisa no
     cesto, e so recomeca quando fechar o separador. */
  var CHAVE_CRON = 'mvnCronDesde';
  var relogio = null;

  function cronometro() {
    var caixa = gaveta.querySelector('[data-mvn-cron]');
    var alvo = gaveta.querySelector('[data-mvn-cron-n]');
    clearInterval(relogio);
    if (!caixa || !alvo) return;

    var desde;
    try { desde = parseInt(sessionStorage.getItem(CHAVE_CRON), 10); } catch (e) { desde = null; }
    if (!desde || isNaN(desde)) {
      desde = Date.now();
      try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
    }

    function tique() {
      var resta = 600 - Math.floor((Date.now() - desde) / 1000);
      if (resta <= 0) {           // acabou: volta a contar, nao fica em 00:00
        desde = Date.now();
        try { sessionStorage.setItem(CHAVE_CRON, String(desde)); } catch (e) {}
        resta = 600;
      }
      var mm = Math.floor(resta / 60), ss = resta % 60;
      alvo.textContent = (mm < 10 ? '0' : '') + mm + ':' + (ss < 10 ? '0' : '') + ss;
    }
    tique();
    relogio = setInterval(tique, 1000);
  }

  /* ---------- seguro de envio ----------
     Nao e uma opcao do carrinho: e um produto (`parcel-insurance`, 2,90 €).
     Ligar poe-o no cesto, desligar tira-o. */
  function seguro(caixa) {
    var idVariante = caixa.getAttribute('data-mvn-seguro');
    var chave = caixa.getAttribute('data-mvn-seguro-chave');
    var rot = caixa.closest('.mvn-seguro');
    if (rot) { rot.classList.toggle('ligado', caixa.checked); rot.classList.add('a-ligar'); }
    var promessa = caixa.checked
      ? enviar('/cart/add.js', { id: Number(idVariante), quantity: 1 })
      : enviar('/cart/change.js', { id: chave, quantity: 0 });
    return promessa.catch(function () { redesenhar(); });
  }

  /* ---------- mexer no carrinho ---------- */
  function mudar(chave, quantidade) {
    gaveta.classList.add('a-trabalhar');
    return enviar('/cart/change.js', { id: chave, quantity: quantidade })
      .then(function () { gaveta.classList.remove('a-trabalhar'); })
      .catch(function () { gaveta.classList.remove('a-trabalhar'); });
  }

  function juntar(idVariante, botao) {
    botao.disabled = true;
    return enviar('/cart/add.js', { id: Number(idVariante), quantity: 1 })
      .catch(function () { botao.disabled = false; redesenhar(); });
  }

  /* ---------- ligacoes ---------- */
  function ligar() {
    if (!montar()) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('.mvn-gaveta__fechar') || e.target.classList.contains('mvn-veu')) {
        e.preventDefault(); fechar(); return;
      }

      // o saco do cabecalho abre a gaveta em vez de ir para /cart
      var saco = e.target.closest('a[href$="/cart"], a[href*="/cart?"], .cart-link, #cart-drawer-toggle');
      if (saco && !e.target.closest('.mvn-gaveta')) {
        e.preventDefault();
        gaveta.classList.add('a-trabalhar');
        abrir();
        redesenhar().then(function () { gaveta.classList.remove('a-trabalhar'); })
                    .catch(function () { gaveta.classList.remove('a-trabalhar'); });
        return;
      }

      var b = e.target.closest('[data-mvn-qtd]');
      if (b) {
        e.preventDefault();
        var linha = b.closest('.mvn-linha');
        if (!linha) return;
        var chave = linha.getAttribute('data-chave');
        var n = parseInt(linha.querySelector('.mvn-passo__n').textContent.trim(), 10) || 1;
        var acao = b.getAttribute('data-mvn-qtd');
        if (acao === 'tirar') { mudar(chave, 0); return; }
        if (acao === 'menos') { mudar(chave, Math.max(0, n - 1)); return; }
        if (acao === 'mais') { mudar(chave, n + 1); return; }
      }

      var j = e.target.closest('button[data-mvn-juntar]');
      if (j) { e.preventDefault(); juntar(j.getAttribute('data-mvn-juntar'), j); }
    });

    document.addEventListener('change', function (e) {
      var vs = e.target.closest('[data-mvn-sug-vs]');
      if (vs) {
        var d = JSON.parse(vs.querySelector('script').textContent);
        var esc = [].map.call(vs.querySelectorAll('select'), function (x) { return x.value; });
        var i = d[0].findIndex(function (o) { return o.join('|') === esc.join('|'); });
        var bt = vs.closest('.mvn-sug').querySelector('[data-mvn-juntar]');
        if (bt) { if (i >= 0 && d[2][i]) { bt.setAttribute('data-mvn-juntar', d[1][i]); bt.disabled = false; } else { bt.disabled = true; } }
        return;
      }
      var c = e.target.closest('[data-mvn-seguro]');
      if (c) seguro(c);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && gaveta.classList.contains('aberta')) fechar();
    });

    /* **o encaixe no tema.** O Symmetry chama isto depois de por no carrinho.
       Deixa-se o dele correr primeiro (actualiza contadores e o botao) e so se
       lhe acrescenta a gaveta no fim — assim, se um dia isto falhar, a loja
       continua a vender como vendia. */
    if (window.theme && typeof theme.addedToCartHandler === 'function') {
      var original = theme.addedToCartHandler;
      theme.addedToCartHandler = function () {
        try { original.apply(this, arguments); } catch (err) {}
        try { theme.removeAddedCartDrawer(); } catch (err) {}
        /* **Abre-se JA, nao depois de o servidor responder.** Esperar pela
           resposta deixava um segundo em que nao acontecia nada — e nesse
           intervalo via-se a barra do tema a deslizar pela pagina. Abre-se
           logo, com o conteudo apagado e um pinhao a rodar, e o conteudo
           entra durante a propria animacao de entrada. */
        gaveta.classList.add('a-trabalhar');
        abrir();
        redesenhar().then(function () { gaveta.classList.remove('a-trabalhar'); })
                    .catch(function () { gaveta.classList.remove('a-trabalhar'); });
      };
    }

    cronometro();

    // se outra coisa qualquer mexer no carrinho, a gaveta acompanha
    document.documentElement.addEventListener('theme:cartchanged', function () {
      if (gaveta.classList.contains('aberta')) redesenhar();
    });
  }

  window.__mvnGaveta = { abrir: function () { if (!gaveta && !montar()) return; gaveta.classList.add('a-trabalhar'); abrir();
    redesenhar().then(function () { gaveta.classList.remove('a-trabalhar'); }).catch(function () { gaveta.classList.remove('a-trabalhar'); }); } };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
})();

/* ---------------------------------------------------------------
   Ligação ao Dawn (02/10/2026). O `product-form` do Dawn e o bundle procuram
   um <cart-drawer> e chamam `getSectionsToRender()` e `renderContents()`.
   Este elemento é a nossa gaveta: depois de juntar ao carrinho abre-a e
   volta a desenhá-la pelo Liquid, como fazia no tema antigo.
   --------------------------------------------------------------- */
(function () {
  if (customElements.get('cart-drawer')) return;
  class MvnCartDrawer extends HTMLElement {
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    setActiveElement() {}
    open() { if (window.__mvnGaveta) window.__mvnGaveta.abrir(); }
    renderContents() { this.classList.remove('is-empty'); this.open(); }
  }
  customElements.define('cart-drawer', MvnCartDrawer);
})();
